import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { de, en } from 'vuetify/locale'

export default createVuetify({
  // Without this Vuetify runs on 'en', and that is not only a matter of button labels: the
  // locale drives the date adapter, so a calendar would start its week on SUNDAY and print
  // English weekday initials at German users. Setting it to 'de' fixes the week start, the
  // weekday and header formats, and the component strings in one go.
  //
  // It does NOT control the clock: VTimePicker defaults to 12-hour regardless of locale and
  // needs format="24hr" at the call site.
  locale: {
    locale: 'de',
    fallback: 'en',
    messages: { de, en },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          background: '#f4f6fb',
          surface: '#ffffff',
          primary: '#000080',
          secondary: '#15157a',
          accent: '#e8a200',
          error: '#e23a3a',
          info: '#000080',
          success: '#15a06b',
          warning: '#f08a24',
          'on-surface': '#15161c',
        },
        variables: {
          'border-color': '#e6e9f2',
          'border-opacity': 1,
        },
      },
    },
  },
  defaults: {
    VCard: { rounded: 'lg' },
    VBtn: { rounded: 'lg' },
    VTextField: { variant: 'filled', density: 'comfortable', color: 'primary' },
    VSelect: { variant: 'filled', density: 'comfortable', color: 'primary' },
    // VAutocomplete inherits none of VTextField's defaults — it is its own component as far as
    // the defaults map is concerned. Without its own entry it renders at Vuetify's default
    // density, which is 8px taller, so the station fields stood proud of every other field in
    // the connection search's filter row.
    VAutocomplete: { variant: 'filled', density: 'comfortable', color: 'primary' },
  },
})
